import _ from "lodash";
import QuickPickService from "./quick-pick.service";
import UtilsService from "./utils.service";

const OPERATOR_TEXT_TO_KEY_MAP = {
  'equals': '=',
  'does not equal': '!=',
  'contains': 'like',
  'does not contain': 'notlike',
  'starts with': 'startswith',
  'ends with': 'endswith',
  'less than': '<',
  'less than or equal to': '<=',
  'greater than': '>',
  'greater than or equal to': '>=',
  'in': 'in',
  'not in': 'notin',
  'empty': 'empty',
  'not empty': 'notempty',
  'is less than': '<',
  'is less than or equal to': '<=',
  'is greater than': '>',
  'is greater than or equal to': '>=',
  'is prior to': '<',
  'is on or prior to': '<=',
  'is after': '>',
  'is on or after': '>=',
  'is any of': 'in', // deprecated
  'is not from': 'notin', // deprecated
  'is empty': 'empty',
  'is not empty': 'notempty',
};


/// todo copied from quickPick.vue
const PERIPHERAL_FIELDS = {
  'camera': true,
  'display': true,
  'microphone': true,
  'touch_panel': true
};

const FILTER_TYPES = QuickPickService.getFilterTypes();

export default {

  migrateFilterExpressionToApiFilter: function (oldFilter, migrateDatasetName) {
    let self = this;
    if (!oldFilter) return {};

    let newFilter = {};

    let oldFilterGroups = oldFilter.filterGroups;

    function buildNewFilter(oldSingleFilter, noop) {
      const EMPTY = {
        noop: noop
      };
      let operatorText = oldSingleFilter.operatorText;
      // const EMPTY = {
      //   field: oldSingleFilter.field,
      //   valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
      // };
      if (oldSingleFilter.operatorText === 'is' || oldSingleFilter.operatorText === 'quick pick') {
        let qpType = oldSingleFilter.widget || self.getQuickPickType();
        if (qpType === 'toggles') {
          // this migrates previously created filters or quick starts who don't have data set
          if (oldSingleFilter.quickPickValues && !oldSingleFilter.data && migrateDatasetName) { // migrateDatasetName only needs to be passed in to migrate old filter that don't have the data set already
            let items = _.get(FILTER_TYPES, [oldSingleFilter.datasetId || migrateDatasetName, oldSingleFilter.quickPickId ? oldSingleFilter.quickPickId : oldSingleFilter.field], [])
            oldSingleFilter.data = { selections : oldSingleFilter && oldSingleFilter.quickPickValues ? oldSingleFilter.quickPickValues : undefined, allValues: items.map(item => item.value) }
          }
          let allSelected = oldSingleFilter.quickPickValues ? oldSingleFilter.quickPickValues.length === oldSingleFilter.data.allValues.length : false;
          if (allSelected) {
            return EMPTY;
          } else {
            if (PERIPHERAL_FIELDS[oldSingleFilter.field] && oldSingleFilter.type !== 'metric') {
              // special case for peripherals
              // TODO: Peripherals quick pick only works for datasets. Will metrics filters ever need peripherals quick picks?
              return constructPeripheralQuickPickFilter(oldSingleFilter);
            } else {
              return constructMetricOrDatasetQuickPickFilter(oldSingleFilter, noop);
            }
          }
        } else if (qpType === 'ids') {
          if (oldSingleFilter.quickPickValues && oldSingleFilter.quickPickValues.length) {
            return {
              field: oldSingleFilter.field,
              negate: false,
              valueIn: oldSingleFilter.quickPickValues ? oldSingleFilter.quickPickValues.map(s => s.id) : [],
              valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
            };
          } else {
            return EMPTY;
          }
        } else {
          // this should never happen
          return {
            field: oldSingleFilter.field,
            valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
          };
        }

      } else if (oldSingleFilter.operatorText === 'in' || oldSingleFilter.operatorText === 'not in') {
        if (oldSingleFilter.queryVar && oldSingleFilter.queryVar.length) {
          return {
            field: oldSingleFilter.field,
            negate: 'notin' === OPERATOR_TEXT_TO_KEY_MAP[oldSingleFilter.operatorText],
            valueIn: oldSingleFilter.queryVar.split(','), // todo this will break if strings/tags contain commas 
            valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
          };
        } else {
          return EMPTY;
        }
      } else if (oldSingleFilter.operatorText === 'is empty' || oldSingleFilter.operatorText === 'is not empty') {
        return {
          field: oldSingleFilter.field,
          exists: 'notempty' === OPERATOR_TEXT_TO_KEY_MAP[oldSingleFilter.operatorText],
          valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
        };
      } else if ((oldSingleFilter.operatorText === 'contains' || oldSingleFilter.operatorText === 'does not contain' ) &&
        (oldSingleFilter.type === 'list' || oldSingleFilter.type === 'metricList')) {
        // todo this is an odd filter which is really only used for endpoint tags because of how they are stored
        // it has to do a "like" comparison
        // this should be migrated to a normal "in" operation and the back end should decide how to handle it due to 
        // how they are stored vs the client choosing
        if (oldSingleFilter.queryVar && oldSingleFilter.queryVar.length) {
          let values = oldSingleFilter.queryVar.split(',');
          if (values.length === 1) {
            return {
              field: oldSingleFilter.field,
              operator: OPERATOR_TEXT_TO_KEY_MAP[oldSingleFilter.operatorText],
              value: oldSingleFilter.type === 'number' ? UtilsService.convertToSeconds(oldSingleFilter.queryVar) : oldSingleFilter.queryVar,
              valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
            };
          } else {
            let filters = [];
            values.forEach(value => {
              filters.push({
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP[oldSingleFilter.operatorText],
                value: oldSingleFilter.type === 'number' ? UtilsService.convertToSeconds(oldSingleFilter.queryVar) : oldSingleFilter.queryVar,
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              });
            });
            return {
              conjunction: oldSingleFilter.operatorText === 'contains' ? 'OR' : 'AND',
              filters: filters,
            };
          }
        } else {
          return EMPTY;
        }
      } else if ((oldSingleFilter.operatorText === 'contains' || oldSingleFilter.operatorText === 'does not contain' ) &&
        (oldSingleFilter.type === 'starRating' || oldSingleFilter.type === 'metricStarRating' )) {
        // todo migrate to an "in" filter
        if (oldSingleFilter.queryVar && oldSingleFilter.queryVar.length) {
          let values = oldSingleFilter.queryVar.split(',');
          if (values.length === 1) {
            return {
              field: oldSingleFilter.field,
              operator: OPERATOR_TEXT_TO_KEY_MAP[oldSingleFilter.operatorText === 'contains' ? 'equals' : 'does not equal'],
              value: oldSingleFilter.queryVar,
              valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
            };
          } else {
            let filters = [];
            values.forEach(value => {
              filters.push({
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP[oldSingleFilter.operatorText === 'contains' ? 'equals' : 'does not equal'],
                value: value,
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              });
            });
            return {
              conjunction: oldSingleFilter.operatorText === 'contains' ? 'OR' : 'AND',
              filters: filters,
            };
          }
        } else {
          return EMPTY;
        }
      } else if (OPERATOR_TEXT_TO_KEY_MAP[oldSingleFilter.operatorText] 
        && (oldSingleFilter.queryVar || operatorText === 'is empty' || operatorText === 'is not empty' || operatorText === 'empty' || operatorText === 'not empty')) {
        return {
          field: oldSingleFilter.field,
          operator: OPERATOR_TEXT_TO_KEY_MAP[oldSingleFilter.operatorText],
          value: oldSingleFilter.type === 'number' ? UtilsService.convertToSeconds(oldSingleFilter.queryVar) : oldSingleFilter.queryVar,
          valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
        };
      } else {
        return EMPTY;
      }
    }

    function constructMetricOrDatasetQuickPickFilter(oldSingleFilter, noop) {
      const EMPTY = {
        noop: noop
      };
      let values = oldSingleFilter.quickPickValues;
      if (values && values.length === 1 && values[0].toLowerCase() !== 'other') {
        // when the user clicks "only" we want to set up an "equals" oldSingleFilter
        return {
          field: oldSingleFilter.field,
          operator: OPERATOR_TEXT_TO_KEY_MAP['equals'],
          value: values[0], // oldSingleFilter.queryVar, // values[0].toLowerCase()
          valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
        };
      } else if (oldSingleFilter.data) {
        let items = oldSingleFilter.data.allValues;
        let excludedValues = _.difference(items, oldSingleFilter.quickPickValues);
        let otherDeselected = excludedValues.includes('Other');

        if (excludedValues.length && !otherDeselected) {
          // default filter behavior, apply "not in" filter
          return {
            field: oldSingleFilter.field,
            negate: true,
            valueIn: excludedValues,
            valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
          };
        } else if (otherDeselected && values.length) {
          // if the QP has an "other" option, and it is deselected, we have to create an "in" oldSingleFilter instead
          // TODO: Untested. Currently no metric quick picks with "other" option.
          return {
            field: oldSingleFilter.field,
            negate: false,
            valueIn: values,
            valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
          };
        } else if (otherDeselected && !values.length) {
          // TODO: is there a better way to handle "Other" case when all options are deselected?
          // we have to create a filter that will return no results so that the user sees an empty dataset
          // TODO: Untested. Currently no metric quick picks with "other" option.
          // This isn't technically what our oldSingleFilter is, but it should be a good representation to the user
          return {
            field: oldSingleFilter.field,
            negate: false,
            valueIn: ['ReturnNoResults'],
            valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
          };
        } else {
          return EMPTY;
        }
      }
    }
    
    function constructPeripheralQuickPickFilter(oldSingleFilter) {
      let qpValues = oldSingleFilter.quickPickValues;
      // microphone is a special case and the filters can be slightly different
      let isMicrophone = oldSingleFilter.field.toLowerCase() === 'microphone';

      // qpValues will be in the set ("Good", "Bad", "Neutral")
      // TODO: should we set oldSingleFilter.queryVar for these peripherals filters? if so, what should it be?
      if (_.isEqual(qpValues, ['Good'])) {
        // e.g. [(Microphone does not contain Connected=none | Not Connected=none) AND (Microphone contains Not Connected=none)]
        oldSingleFilter.value = 
          isMicrophone 
            ? oldSingleFilter.field + '!="*Connected=none | Not Connected=none*";' + oldSingleFilter.field + '=="*Not Connected=none*"' 
            : oldSingleFilter.field + '!="Connected=none | Not Connected=none";' + oldSingleFilter.field + '=="*Not Connected=none*"';
        if (isMicrophone) {
          return {
            conjunction: 'AND',
            filters: [
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['does not contain'],
                value: 'Connected=none | Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              },
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['contains'],
                value: 'Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              }
            ]
          };
        } else {
          return {
            conjunction: 'AND',
            filters: [
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['does not equal'],
                value: 'Connected=none | Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              },
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['contains'],
                value: 'Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              }
            ]
          };
        }
      } else if (_.isEqual(qpValues, ['Bad'])) {
        // e.g. [(Microphone does not equal Unknown) AND (Microphone does not contain Not Connected=none)]
        return {
          conjunction: 'AND',
          filters: [
            {
              field: oldSingleFilter.field,
              operator: OPERATOR_TEXT_TO_KEY_MAP['does not equal'],
              value: 'Unknown',
              valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
            },
            {
              field: oldSingleFilter.field,
              operator: OPERATOR_TEXT_TO_KEY_MAP['does not contain'],
              value: 'Not Connected=none',
              valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
            }
          ]
        };
      } else if (_.isEqual(qpValues, ['Neutral'])) {
        // e.g. [(Microphone contains Connected=none | Not Connected=none) OR (Microphone equals Unknown)]
        if (isMicrophone) {
          return {
            conjunction: 'OR',
            filters: [
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['contain'],
                value: 'Connected=none | Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              },
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['equals'],
                value: 'Unknown',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              }
            ]
          };
        } else {
          return {
            conjunction: 'OR',
            filters: [
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['equal'],
                value: 'Connected=none | Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              },
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['equals'],
                value: 'Unknown',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              }
            ]
          };
        }
      } else if (qpValues.includes('Good') && qpValues.includes('Bad') && !qpValues.includes('Neutral')) {
        // e.g. [(Microphone does not contain Connected=none | Not Connected=none) AND (Microphone does not equal Unknown)]
        if (isMicrophone) {
          return {
            conjunction: 'AND',
            filters: [
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['does not contain'],
                value: 'Connected=none | Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              },
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['does not equal'],
                value: 'Unknown',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              }
            ]
          };
        } else {
          return {
            conjunction: 'AND',
            filters: [
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['does not equal'],
                value: 'Connected=none | Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              },
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['does not equal'],
                value: 'Unknown',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              }
            ]
          };
        }
      } else if (qpValues.includes('Good') && qpValues.includes('Neutral') && !qpValues.includes('Bad')) {
        // e.g. [(Microphone contains Not Connected=none) OR (Microphone equals Unknown)]
        return {
          conjunction: 'OR',
          filters: [
            {
              field: oldSingleFilter.field,
              operator: OPERATOR_TEXT_TO_KEY_MAP['contains'],
              value: 'Not Connected=none',
              valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
            },
            {
              field: oldSingleFilter.field,
              operator: OPERATOR_TEXT_TO_KEY_MAP['equals'],
              value: 'Unknown',
              valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
            }
          ]
        };
      } else if (qpValues.includes('Bad') && qpValues.includes('Neutral') && !qpValues.includes('Good')) {
        // e.g. [(Microphone contains Connected=none | Not Connected=none) OR (Microphone equals Unknown) OR (Microphone does not contain Not Connected=none)]
        if (isMicrophone) {
          return {
            conjunction: 'OR',
            filters: [
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['contains'],
                value: 'Connected=none | Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              },
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['equals'],
                value: 'Unknown',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              },
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['does not contain'],
                value: 'Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              }
            ]
          };
        } else {
          return {
            conjunction: 'OR',
            filters: [
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['equals'],
                value: 'Connected=none | Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              },
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['equals'],
                value: 'Unknown',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              },
              {
                field: oldSingleFilter.field,
                operator: OPERATOR_TEXT_TO_KEY_MAP['does not contain'],
                value: 'Not Connected=none',
                valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
              }
            ]
          };
        }
      } else if (!qpValues.length) {
        // e.g. [(Microphone does not equal Unknown) AND (Microphone does not contain Connected)]
        return {
          conjunction: 'AND',
          filters: [
            {
              field: oldSingleFilter.field,
              operator: OPERATOR_TEXT_TO_KEY_MAP['does not equal'],
              value: 'Unknown',
              valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
            },
            {
              field: oldSingleFilter.field,
              operator: OPERATOR_TEXT_TO_KEY_MAP['does not contain'],
              value: 'Connected',
              valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
            }
          ]
        };
      } else {
        return {
          field: oldSingleFilter.field,
          valueType: oldSingleFilter.type === 'number' ? 'numeric' : 'string', // todo datetime
        }; // no filter
      }
    }
    
    
    // is there more than one oldFilter?
    if (!oldFilterGroups || oldFilterGroups.length === 0 || (oldFilterGroups.length === 1 && oldFilterGroups[0].filters.length === 0)) {
      return newFilter;
    } else if (oldFilterGroups.length === 1 && oldFilterGroups[0].filters.length === 1) {
      newFilter = buildNewFilter(oldFilterGroups[0].filters[0], true);
    } else if (oldFilterGroups.length === 1) {
      let oldFilterGroup = oldFilterGroups[0];
      let filters = {};
      filters.conjunction = oldFilterGroup.operator.toUpperCase();
      filters.filters = [];
      oldFilterGroup.filters.forEach(filter => {
        filters.filters.push(buildNewFilter(filter, 'AND' === filters.conjunction));
      });
      return filters;
    } else {
      newFilter.conjunction = oldFilter.operator.toUpperCase();
      newFilter.filters = [];
      oldFilterGroups.forEach(oldFilterGroup => {
        let filters = {};
        if (oldFilterGroup.filters.length <= 1) {
          filters = buildNewFilter(oldFilterGroup.filters[0], true);
        } else {
          filters.conjunction = oldFilterGroup.operator.toUpperCase();
          filters.filters = [];
          oldFilterGroup.filters.forEach(filter => {
            filters.filters.push(buildNewFilter(filter, 'AND' === filters.conjunction));
          });
        }
        newFilter.filters.push(filters);
      });
    }
    return newFilter;
  },

  // todo move this to metadata
   getQuickPickType: function (fieldName, datasetName) {
     if ((fieldName === 'endpoint_id' && (datasetName === 'endpoint' || datasetName === 'endpoints' || datasetName === 'calls' || datasetName === 'call'))
       || (fieldName === 'system_id' && (datasetName === 'systems' || datasetName === 'bridges' || datasetName === 'callcontrols'|| datasetName === 'callcontrol') )
       || (fieldName === 'trunk_id' && (datasetName === 'trunks' || datasetName === 'trunk'))
       || (fieldName === 'network_id' && (datasetName === 'endpoints' || datasetName === 'calls' || datasetName === 'participants'))
       || (fieldName === 'van_room.buildingKey' && (datasetName === 'spaces'))
       || (fieldName === 'network.buildingKey' && (datasetName === 'networks'))
       || (fieldName === 'dimipsubnet.dimipsubnetsid' && (datasetName === 'summaryview.networkInsightsDetail'))
       || (fieldName === 'dimbuilding.buildingkey' && (datasetName === 'summaryview.networkInsightsDetail'))
       || (fieldName === 'dimipsubnet.dimipsubnetsid' && (datasetName === 'networks'))
     ) {
       return 'ids';
     }
     return 'toggles';
   }
};
